<div class="sh-google-maps-dialog">
    <div class="sh-dialog__content sh-google-maps-dialog__content">
        <sh-notification *ngIf="invalidCoordinatesError$ | async" [icon]="'warning'" [message]="invalidMsg" [type]="notificationType.Warning"></sh-notification>
        <sh-notification
            *ngIf="!(invalidCoordinatesError$ | async)"
            [icon]="'info'"
            [message]="'modules.general.form.location.click-to-add-location' | translate"
            [type]="notificationType.Update"
        ></sh-notification>

        <div class="sh-visually-hidden">
            <button
                id="location"
                class="sh-gm-button--small"
                (click)="jumpToMarker()"
                [disabled]="!(markerPosition$ | async)"
                [title]="'modules.general.form.location.move-to-selected-location' | translate"
            >
                <svg [class.no-marker]="!(markerPosition$ | async)" sh-icon [name]="'location'" aria-hidden="true"></svg>
            </button>
            <button
                id="delete"
                class="sh-gm-button--small"
                (click)="deleteMarker()"
                [disabled]="!(markerPosition$ | async)"
                [title]="'modules.general.form.location.delete-selected-location' | translate"
            >
                <svg [class.no-marker]="!(markerPosition$ | async)" sh-icon [name]="'trash'" aria-hidden="true"></svg>
            </button>
        </div>

        <google-map
            #googleMap
            *ngIf="apiLoaded$ | async"
            class="sh-google-maps-dialog__map"
            [options]="googleMapsOptions$ | async"
            (mapClick)="addOrUpdateMarker($event)"
            [width]="'100%'"
            [height]="'100%'"
        >
            <map-marker
                *ngIf="markerPosition$ | async as markerPosition"
                [position]="markerPosition"
                [options]="markerOptions"
                (mapDragend)="addOrUpdateMarker($event)"
            ></map-marker>
        </google-map>
    </div>
    <div class="sh-dialog__footer">
        <div class="sh-action-group -sh-align-end">
            <button class="sh-button sh-action-group__item" [disabled]="!(markerPosition$ | async)" (click)="applyLocation()">
                {{ "actions.common.apply" | translate }}
            </button>
            <button class="sh-button--secondary sh-action-group__item" (click)="close()">{{ "actions.common.cancel" | translate }}</button>
        </div>
    </div>
</div>
